export default __webpack_public_path__ + "static/media/notifications_none-24px.7db23329.svg";